import { EdiConnectionType } from '../../enum/edi';
import { EdiConnectionDetails } from '../../models/edi/connection-details.type';
import { BaseDto } from '../base.dto';

export class EdiConnectionDto extends BaseDto {
  type: EdiConnectionType;
  details: EdiConnectionDetails;
}
